import React from "react";
import { Button } from "react-bootstrap";

const UploadFilePrompt = ({
  hasDoc,
  uploading,
  onCancel,
  onPickFile,
  onFileChange,
  fileInputId = "fileInputRef",
  forceUpload = false,
}) => {
  return (
    <div className="text-center">
      {hasDoc && !forceUpload ? (
        <>
          <p>If you upload a file, it will replace the current file.</p>

          {uploading ? (
            <div className="d-flex justify-content-center mt-3">
              <p>Uploading...</p>
            </div>
          ) : (
            <div className="d-flex justify-content-end gap-3 mt-3">
              <Button
                className="bg-gray-300 text-black border-black px-4"
                onClick={onCancel}
              >
                No
              </Button>

              <Button
                variant="primary"
                className="px-4"
                onClick={() => document.getElementById(fileInputId)?.click()}
              >
                Yes
              </Button>
            </div>
          )}
        </>
      ) : (
        <>
          <p>Please select a file to upload</p>

          <div className="d-flex justify-content-center mt-3">
            {uploading ? (
              <p>Uploading...</p>
            ) : (
              <Button
                onClick={() => document.getElementById(fileInputId)?.click()}
              >
                Choose File
              </Button>
            )}
          </div>
        </>
      )}

      <input
        type="file"
        id={fileInputId}
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFileChange(file);
        }}
      />
    </div>
  );
};

export default UploadFilePrompt;
